  import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image, UnorderedList, ListItem } from "@chakra-ui/react";
  import { DateFilter, TopDisplay,UploadButton } from "../../../components";
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState ,useEffect} from "react";
  import styled from "@emotion/styled";
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import apiCall from "../../../utils/apiCall";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import ReactPaginate from 'react-paginate';
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import { format } from "date-fns";
  import apiCallFormData from '../../../utils/apiFormDataCall';
  import { BsUpload as UploadIcon} from "react-icons/bs";
  import {
    Grid,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverArrow,
  } from '@chakra-ui/react'
  import {useAtom,atom} from 'jotai'
  import { modalAtom, notificationAtom, openAtom, openNAtom } from "../../../context";
  import { Loader } from "../../../customs";
  import { useDropzone } from "react-dropzone";
  import { Field, Form, Formik } from "formik";
  import * as Yup from 'yup';
  import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
import moment from "moment";
  const src=`/public-assets/upload_icon.png`;




  const indexAtom = atom<number | null>(null);
  const list = [
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
  ]

  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    ":nth-of-type(5)":{
      maxWidth:'250px',
      overflow:'hidden'
    },
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }


  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `

  export default function Applications() {
    const [hide,set_hide] = useState<boolean>(true);
    const [activeIndex] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const queryClient = useQueryClient();
    const [selected_examperiod,set_selected_examperiod] = useState<any>(null);
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);
    const [date_range,set_date_range] = useState<any>({startDate:'',endDate:''});

    const [search,set_search] = useState('');
    const isSearching = search.trim() !== '';

    const itemsPerPage = 100;
    const [pageNumber,set_pageNumber] = useState(1); // server-side page, used when not searching
    const [itemOffset, setItemOffset] = useState(0); // client-side offset, used only while searching

    useEffect(()=>{
      set_pageNumber(1);
    },[selected_examperiod?.Id])

    useEffect(()=>{
      setItemOffset(0);
    },[search])

    // Only fetch the single page needed for the current view - avoids pulling
    // the entire dataset into memory on every load.
    const { data: pagedResult, isLoading: isLoadingPage } = useQuery(
      ["applications-page", selected_examperiod?.Id || "en", pageNumber],
      async () => {
        const response = await apiCall().get(
          `Exam/GetAllStudent?PageNumber=${pageNumber}&PageSize=${itemsPerPage}`
        );
        return response.data;
      },
      {
        enabled: !isSearching,
        keepPreviousData: true,
        select: (data: any) => ({
          items: data?.reportItems || [],
          pageCount: data?.PageCount || 1,
          totalCount: data?.TotalCount ?? (data?.reportItems || []).length,
        }),
      }
    );

    // Full dataset is only pulled (across all pages) when the user actually
    // searches, since this endpoint has no server-side search param. Uses a
    // large page size and bounded concurrency to keep round trips to a minimum.
    const { data: searchAllData, isLoading: isLoadingSearchAll } = useQuery(
      ["applications-search-all", selected_examperiod?.Id || "en"],
      async () => {
        try {
          const searchPageSize = 1000;
          const firstPageResponse = await apiCall().get(
            `Exam/GetAllStudent?PageNumber=1&PageSize=${searchPageSize}`
          );
          const totalPages = firstPageResponse.data?.PageCount || 1;
          let allData = firstPageResponse.data?.reportItems || [];

          if (totalPages > 1) {
            const remainingPages = [];
            for (let page = 2; page <= totalPages; page++) remainingPages.push(page);

            const batchSize = 5;
            for (let i = 0; i < remainingPages.length; i += batchSize) {
              const batch = remainingPages.slice(i, i + batchSize);
              const responses = await Promise.all(
                batch.map((page) =>
                  apiCall().get(`Exam/GetAllStudent?PageNumber=${page}&PageSize=${searchPageSize}`)
                )
              );
              responses.forEach((res) => {
                allData = [...allData, ...(res.data?.reportItems || [])];
              });
            }
          }

          return allData;
        } catch (error) {
          console.error("Error fetching students:", error);
          return [];
        }
      },
      {
        enabled: isSearching,
        staleTime: 5 * 60 * 1000,
      }
    );

    const filter_data = isSearching
      ? (searchAllData || []).filter((student: any) => {
          const trimmedVal = search.trim().toLowerCase();
          const studentNo = student?.StudentNo?.toString().toLowerCase() || "";
          const fullName = `${student?.FirstName || ""} ${student?.LastName || ""}`.toLowerCase();
          return studentNo.includes(trimmedVal) || fullName.includes(trimmedVal);
        })
      : (pagedResult?.items || []);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = isSearching ? filter_data.slice(itemOffset, endOffset) : filter_data;
    const pageCount = isSearching
      ? Math.ceil(filter_data.length / itemsPerPage)
      : (pagedResult?.pageCount || 1);
    const totalCount = isSearching ? filter_data.length : (pagedResult?.totalCount ?? filter_data.length);
    const displayOffset = isSearching ? itemOffset : (pageNumber - 1) * itemsPerPage;
    const displayEnd = Math.min(displayOffset + itemsPerPage, totalCount);

    const handlePageClick = (event:any) => {
      if (isSearching) {
        const newOffset = (event.selected * itemsPerPage) % (filter_data.length || 1);
        setItemOffset(newOffset);
      } else {
        set_pageNumber(event.selected + 1);
      }
    };

    const isLoading = isSearching ? isLoadingSearchAll : isLoadingPage;

    return (
      <>
        {isLoading?<Loader />:
          <Box>
          <TopDisplay label="Students/Update StartLevel Via option" button_array={[
            
          ]} />
            <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              type="text"
              value={search}
              onChange={(e) => {
                set_search(e.target.value);
              }}
              placeholder="Search by Student No or Name"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
            />
            <span
              style={{
                position: "absolute",
                zIndex: "1",
                right: "10px",
                cursor: "pointer",
                top: "12px",
              }}
              onClick={() => {
                set_search("");
                set_pageNumber(1);
              }}
            >
              <ReloadIcon />
            </span>
          </InputGroup>


              {/* <Select placeholder="Status" width="100px" bg="var(--white-color)" 
                borderColor="var(dark-green-color)">
              </Select> */}
              {/* <DateFilter text="Date Range" onChange={set_date_range} /> */}
            </Flex>
            <Flex mt="25px" flexDir="column" gap="10px">
              <Heading m="0" fontSize="1rem">All Applications</Heading>
              <Text m="0" fontSize=".8rem">showing {displayOffset} - {displayEnd} of {totalCount}</Text>
            </Flex>
        {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size="sm" variant="striped" sx={{ tableLayout: 'auto', width: '100%' }}>
      <Thead>
      <Tr>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Student Number</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>First Name</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Last Names</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Gender</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Phone No</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Email</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Subject</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Induction</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>StartLevel</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Level</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Exam Diet</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Address</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Reg.Date</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam Date</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Resit</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Deffered</Th> */}
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam Status</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '50px' }}></Th>
      </Tr>
    </Thead>
    <Tbody>
      {currentItems.map((eUpgradeScore: any, index: number) => (
        <ROWSTYLE key={eUpgradeScore.Id}>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.StudentNo || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.FirstName || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2, whiteSpace: 'normal' }}>{eUpgradeScore.LastName || 'N/A'}</Td>
          {/* <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Gender || 'N/A'}</Td> */}
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.PhoneNumber || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Email || 'N/A'}</Td>
          {/* <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.Subjects?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(', ')?.slice(0, 35) || 'N/A'}</Td> */}
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.InductionStatus || 'N/A'}</Td>
          <Td sx={DataStyle}>{eUpgradeScore.StartLevel||'N/A'}</Td>
          <Td sx={DataStyle}>{eUpgradeScore.Level||'N/A'}</Td>
          {/* <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Level?.ExamDiet || ''}</Td> */}
          <Td title={eUpgradeScore.Address} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>
            {eUpgradeScore.Address || 'N/A'}
          </Td>
        <Td sx={{ ...DataStyle, p: 2 }}>
         {moment.utc(eUpgradeScore.RegistrationDate).local().format("YYYY-MM-DD hh:mm:ss A")}
        </Td>

          {/* <Td sx={{ ...DataStyle, p: 2 }}>{moment(eUpgradeScore.ExamDateTime).format("yyyy-MM-DD")}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.IsResit ? 'Yes' : 'No'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.IsDeffered ? 'Yes' : 'No'}</Td> */}
         <Td sx={DataStyle} minW="60px" w="50px" h="50px">
        <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eUpgradeScore}}/></div>
        </Td>
        </ROWSTYLE>
     ))}
    </Tbody>
  </Table>
</TableContainer>
            :'No Applicant found'  
          }
          <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />

        </StylePaginateBox>

        </Box>
        }
      </>
      
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `

  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }

  const Option = (props:any)=>{
    const index = props.index;
    const candidate= props.candidate;
    const [ind,set_index] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_N_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);
   const [new_StartLevel, set_new_StartLevel] = useState<number | null>(null);
    const queryClient = useQueryClient();

    interface Level {
  Id: number;
  Name: string;
}

    const {data:allLevels} = useQuery(['exam-level'],{
      queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
      select(data){
        return data.data.Data;
      }
    })

    // useEffect(()=>{
    //   set_new_StartLevel(candidate?.StartLevel?.Id)
    // },[])

    const onClick=()=>{
      if(index === ind){
        set_index(null);
        return;
      }
      set_index(index);
    }
    const handleShowProfile = () =>{
      set_index(null);
      set_modal({
        header:'Candidate Details',
        content:<ViewProfile candidate={candidate} />
      })
      set_open(true);
    }

 const { mutate: updateLevel, isLoading: isLoadingUpdate } = useMutation({
    mutationFn: async (newLevelId: number) => {
    return await apiCall().post('/Exam/changeExamStartLevel', {
    StudentMembershipNo: candidate.StudentNo,
    NewLevelId: newLevelId,
            });
            },
            onSuccess(data: any) {
            set_notification({
                type: 'success',
                message: data.data.Message || 'Start Level Updated Successfully',
            });
            set_N_open(true);
            queryClient.invalidateQueries(['applications-page']);
            queryClient.invalidateQueries(['applications-search-all']);
            },

            onError(error: any) {
            set_notification({
                type: 'error',
                message: error?.response?.data?.Message || 'Error Occurred',
            });
            set_N_open(true);
            },
            onSettled: () => {
            set_open(false);
            },
        });


const handleUpdateLevel = () => {
 set_new_StartLevel(null); // let the user choose a level

  // Set the modal content
  set_modal({
    header: 'Update Start Level',
    content: (
      <Flex flexDir="column" gap="20px">
        <Input
          placeholder="Name"
          value={`${candidate?.FirstName || ''} ${candidate?.LastName || ''}`}
          disabled
          w="100%"
        />
        <Input
          placeholder="Current Level"
          value={candidate?.StartLevel || 'N/A'} 
          disabled
          w="100%"
        />
          <Select
          placeholder="Select New Level"
          w="100%"
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            const value = Number(e.target.value);
            set_new_StartLevel(value); // Ensure it's a number
          }}
        >
          {allLevels?.map((eLevel: { Id: number; Name: string }) => (
            <option key={eLevel.Id} value={eLevel.Id}>
              {eLevel.Name}
            </option>
          ))}
        </Select>
       {/* <Select
        placeholder="Select New Level"
        w="100%"
        onChange={(e) => {
            const selected = e.target.value;
            set_new_StartLevel(selected ? parseInt(selected, 10) : null);
        }}
        >
       {allLevels.map((level: { Id: number; Name: string }) => (
        <option key={level.Id} value={level.Id}>
            {level.Name}
        </option>

        ))}
        </Select> */}




        <Flex justify="center" w="100%">
          <Button
            onClick={() => {
              updateLevel(Number(new_StartLevel)); // Call updateLevel with the selected level
            }}
            loadingText="Updating..."
            bg="var(--dark-green-color)"
            color="var(--white-color)"
          >
            {isLoadingUpdate ? 'Loading...' : 'Update'}
          </Button>
        </Flex>
      </Flex>
    ),
  });

  set_open(true); // Open the modal
};

  
        useEffect(() => {
        if (candidate?.StartLevel?.Id) {
            set_new_StartLevel(candidate.StartLevel.Id);
        }
        }, [candidate]);

    return(
      <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
            <GridItem sx={sx} p="8px 4px" onClick={handleUpdateLevel}>Update StartLevel</GridItem>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
    )
  }

  const ViewProfile = (props: any) => {
    // Default image URL
    const defaultImage = "/public-assets/profile-not-found.png"; // Path to your default image
    const imageUrl = props.candidate?.ImageUrl || defaultImage; // Use default image if ImageUrl is not available

    return (
        <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
            <Flex align="center" gap="20px">
                <Image
                    src={imageUrl} // Use the imageUrl variable here
                    width="100px"
                    height="100px"
                    borderRadius="10%"
                    objectFit="cover"
                    objectPosition="center"
                    alt="No image found"
                    fallbackSrc={defaultImage} 
                />
                <Flex flexDir="column">
                    <Heading fontSize="1rem">{`${props.candidate.FirstName} ${props.candidate.LastName}`}</Heading>
                    <Text>Student</Text>
                    <Text>ID: {props.candidate.StudentNo}</Text>
                </Flex>
            </Flex>
            <Grid templateColumns="repeat(3, 1fr)" gap="30px">
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Present Level</Text>
                    <Text fontWeight="500">{props.candidate?.Level}</Text>
                </GridItem>
                {/* <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Amount Paid</Text>
                    <Text fontWeight="500"># {props.candidate.Amount}</Text>
                </GridItem> */}
                {/* <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Study Center</Text>
                    <Text fontWeight="500">{props.candidate.StudyCenter || 'Study Center 1'}</Text>
                </GridItem> */}
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Application Date</Text>
                    <Text fontWeight="500">{format(new Date(props.candidate.RegistrationDate), "dd/MM/yyyy")}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
                    <Text fontWeight="500">{props.candidate.Email}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Gender</Text>
                    <Text fontWeight="500">{props.candidate.Gender}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
                    <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Address</Text>
                    <Text fontWeight="500">{props.candidate.Address}</Text>
                </GridItem>
            </Grid>
        </Flex>
    )}
